import {
  ArrowCircleRight,
  CheckCircleOutline,
  Clear,
  DoDisturbAlt,
  EditOff,
  MoreVert,
  Visibility,
} from "@mui/icons-material";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Checkbox,
  Skeleton,
  Paper,
  TextField,
  ListItemText,
  MenuItem,
  Autocomplete,
  InputBase,
  TableSortLabel,
  Typography,
  Popover,
  useMediaQuery,
  Stack,
  Button,
  Fade,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import SummaryDialog from "../../../components/modals/SummaryDialog";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import LinkList from "../../../components/Buttons/linkList";
import { itemWiseHeader } from "./ItemListData";
import { API, graphqlOperation } from "aws-amplify";
import {
  getCompanyCodeTranslation,
  listAccountMasterv2,
  listItemCategorymaster,
  listItemmastersv2,
  listItemmastersv2Count,
  listPriceType,
} from "../../../graphql";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { showErrorSnackbar, showWarningSnackbar } from "../../../components/snackBar/snakbar";
import { useDispatch, useSelector } from "react-redux";
import { MoneyFormatv3 } from "../../../library/MoneyFormat";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import DirectionsRun from "@mui/icons-material/DirectionsRun";
import Accessibility from "@mui/icons-material/Accessibility";
import DeleteGoodsItem from "../../../components/modals/DeleteGoodsItem";
import AddNewItemRow from "./AddNewItemRow";
import Loader from "../Components/Loader";
import PriceModal from "./PriceModal";

import DeleteSelectedItems from "./DeleteSelectedItems";
import { ThreeDot } from "../../../components/DropDown/ThreeDot";
import { ListSelection_fnForMasters } from "../../../library/ListSelection";
import {
  defaultRowsPerPage,
  defaultRowsPerPageOptions,
  getDefaultSorting,
  handleFreeze,
} from "../../../utils/common";
import { createDebouncedCallback } from "../../../hooks/createDebouncedCallback";
import { isPromise } from "formik";
import SearchIcon from "@mui/icons-material/Search";

import { ClearIcon } from "@mui/x-date-pickers";
import MoneyRanger from "../../../components/formElements/MoneyRanger";
import { Link, useNavigate } from "react-router-dom";
import { updateTitle } from "../../../redux/reducers/titleSlice";
import ListingActive from "../../../components/modals/ListingActive";
import ConfirmExit from "../../../components/modals/ConfirmExit";
import DropDownForListing from "../../../components/DropDown/DropDown";
import ExportData from "../../../components/modals/ExportData";
import { settingsClose } from "../../../redux/reducers/companySkipSave";
import { useThemes } from "../../../components/Theme/theme";
import { useGetCompanyCodeTranslationQuery } from "../../../redux/apis/getCompanyCodeTranslation.api";
import ItemActiveOrInActiveModal from "../../../components/modals/ItemActiveOrInActiveModal";
import { useListPriceTypesQuery } from "../../../redux/apis/pricetype.api";
import { useListAccountMasterv2Query } from "../../../redux/apis/accountMaster.api";
import { setNavigationBlocked } from "../../../redux/reducers/controllNavigation";
import { TableCell } from "../../../components/Table/TableCell";
import { headCell } from "../../LedgerTransaction/components/table/tableHeader";
import useSavePrevent from "../../../hooks/useSavePrevent";
import TableSearchButton from "../Components/TableSearchButton";
import RollingSoon from "../../../components/Ui/RollingSoon";
import { MoneyTextFieldRange } from "../../../components";

const useStyles = (theme) =>
  makeStyles({
    table: {
      "& .MuiTableCell-root": {
        border: "1.5px solid rgba(224, 224, 224, 1)",
        borderBottom: "1.5px solid rgba(224, 224, 224, 1)",
        paddingTop: "1px",
        paddingBottom: "1px",
      },
    },
    stickyCell: {
      // position: "sticky",
      right: 0,
      // backgroundColor: theme?.palette?.TmId.id.toString().includes("9")
      //   ? "#7c7c7c"
      //   : "#bdbdbd",
      zIndex: 10, // Ensure the sticky cell appears above other cells
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        width: "2px", // Adjust this value for the desired border thickness
        backgroundColor: "rgba(224, 224, 224, 1)", // Border color
        zIndex: 11, // Ensure it appears above the cell content
      },
    },
    newTableCell: {
      "& .MuiTableCell-root": {
        borderTop: "3px solid #9b6ab7 !important", // Top border
        borderBottom: "3px solid #9b6ab7", // Bottom border
        borderLeft: "3px solid #9b6ab7", // Left border
        borderRight: "3px solid #9b6ab7", // Right border
        paddingTop: "3px",
        paddingBottom: "4px",
      },
    },
    inActiveRow: {
      "& .MuiTableCell-root": {
        border: "2px solid rgba(224, 224, 224, 1)",
        borderBottom: "2px solid rgba(224, 224, 224, 1)",
        paddingTop: "3px",
        paddingBottom: "4px",
        color: "#cccccc !important",
        fontWeight: 700,
      },
    },
    errorTableCell: {
      "& .MuiTableCell-root": {
        borderTop: "5px solid red !important", // Top border
        borderBottom: "5px solid red", // Bottom border
        borderLeft: "5px solid red", // Left border
        borderRight: "5px solid red", // Right border
        paddingTop: "3px",
        paddingBottom: "4px",
      },
    },
    focusTableCell: {
      // Add specific styles here if needed
    },
  })(theme);
function EnhancedTableHead(props) {
  const {
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
    onDelete,
    setEnableSearch,
    EnableSearch,
    roughList,
    classes,
    data,
    required,
    visiblerowlength,
    setShowActions,
    showActions
  } = props;
  const createSortHandler = (event, property) => {
    onRequestSort(event, property);
  };

  const smalldevices = useMediaQuery("(max-width:480px)");
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  const { theme } = useThemes();


  return (
    <TableHead className="noTableCellBorder">
      <TableRow
        // className={clasess.tableHeader}
        // className={clasess.tableHeader}
        sx={{
          backgroundColor: "background.tablebg",
          "& .MuiTableCell-root": {
            backgroundColor: `${theme.palette.background.tablebg} !important`,
            fontSize: "13px", // Adjust font size as needed
          },
          ".MuiTableCell-head": {
            backgroundColor: "background.tablebg",
            padding: "2px 10px",
            borderBottom: "0px",
          },
          height: "45px",
        }}
      >
        <TableCell
          padding="checkbox"
          sx={{
            ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
              padding: "5px",
            },
          }}
        >
          <Checkbox
            // color="primary"
            sx={{ color: "input.border" }}
            indeterminate={numSelected > 0 && numSelected < visiblerowlength}
            checked={numSelected === visiblerowlength && visiblerowlength !== 0}
            onChange={(e) => {
              console.log({ event: e.target.checked, numSelected, rowCount });
              onSelectAllClick(e);
            }}
            inputProps={{
              "aria-label": "select all desserts",
            }}
            size="small"
          />
        </TableCell>
    
        {itemWiseHeader
          .filter((e) => {
            const requiredAsterisk = (
              <span style={{ color: "#e55353", paddingLeft: "2px" }}>*</span>
            );

            // Set required field based on conditions
            if (e.id === "Unit" && data.type === 2) {
              e.required = "";
            } else if (
              e.id === "SalesAccountName" &&
              data.salesInvoiceFlag === 0
            ) {
              e.required = "";
            } else if (
              e.id === "PurchaseAccountName" &&
              data.purchaseInvoiceFlag === 0
            ) {
              e.required = "";
            } else if (e.id === "DefaultPurchasePrice") {
              e.required = "";
            } else if (e.id === "DefaultSellingPrice") {
              e.required = "";
            } else if (e.id === "Category") {
              e.required = "";
            }else if(e.id==="hsnsaccode" && getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype ===3){
              e.required=""
            } else {
              e.required = requiredAsterisk;
            }
            return !(
              getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype === 1 &&
              (e.id === "TaxabilityCD" || e.id === "hsnsaccode")
            );
            
            
          })
          .map((headCell) => {
            return (
              <TableCell
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={orderBy === headCell.id ? order : false}
                sx={{
                  width: roughList > 0
                    ? (headCell.id === "TaxabilityCD" ? "200px" : headCell.width)
                    : (headCell.id === "TaxabilityCD" ? "200px" : "auto"),
                  minWidth: headCell.id === "TaxabilityCD" ? "200px" : "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: headCell.numeric ? "row-reverse" : "",
                  }}
                >
                  <>
                    <TableSortLabel
                      active={
                        orderBy === headCell.id
                          ? true
                          : "dueDate" === headCell.id &&
                            orderBy === "dueDateTimeStamp"
                            ? true
                            : false
                      }
                      direction={
                        orderBy === "dueDateTimeStamp" || "InvoiceDateTimeStamp"
                          ? order
                          : orderBy === headCell.id
                            ? order
                            : "asc"
                      }
                      onClick={(e) =>
                        headCell?.disableSort
                          ? null
                          : createSortHandler(e, headCell.id)
                      }
                      hideSortIcon={headCell?.disableSort}
                    >
                      <Box sx={{ display: "flex" }}>
                        <Box sx={{ whiteSpace: "nowrap" }}>
                          {headCell.label}{" "}
                          {required === true ? headCell.required : ""}
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {orderBy === headCell.id ? (
                            <Box
                              //  component="span"
                              sx={visuallyHidden}
                            >
                              {order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </Box>
                          ) : null}
                          {/* <SearchIcon
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setEnableSearch((prev) => !prev);
                            }}
                            sx={{ marginLeft: "10px" }}
                            fontSize="small"
                          /> */}
                        </Box>
                      </Box>
                    </TableSortLabel>
                  </>
                </Box>
              </TableCell>
            );
          })}
        <TableCell
          id="action"
          align="center"
          sx={{
            // display: "flex",
            // flexDirection: "row",
            // justifyContent: "space-between",
            position: "sticky",
            right: 0,
            backgroundColor: "background.tablebg",
            zIndex: 999,
            // "&::before": {
            //   content: '""',
            //   position: "absolute",
            //   top: 0,
            //   left: 0,
            //   bottom: 0,
            //   width: "2px", // Adjust this value for the desired border thickness
            //   backgroundColor: "#00000030", // Border color
            //   zIndex: 11, // Ensure it appears above the cell content
            // },
          }}
        >
          <Box sx={{ display: "flex",
              justifyContent:"center", 
              backgroundColor:  'white' ,
              boxShadow:  '0px 4px 8px rgba(0, 0, 0, 0.6)' ,
                "&:active": 
                {
                  transform: "scale(0.92)",
                },
                cursor:"pointer"
           }}>
            <Box sx={{ display: "flex", alignItems: "center", }}
              onClick={(e) => {                  
                setShowActions((pre) => !pre)  
              }}
            >
              Actions
                <ArrowCircleRight
                  sx={{
                    transition: 'transform 0.3s ease-in-out',
                    marginLeft: '10px',
                    transform : !showActions ?  'rotate(0deg)' : 'rotate(180deg)',
                    color:!showActions ? 'gray' : '#ee5b2b',
                  }}
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   e.stopPropagation();
                  //   const actionElement = document.getElementById("action");
                  //   if (actionElement) {
                  //     let pos =
                  //       window.getComputedStyle(actionElement).position ==
                  //       "sticky";
                  //     e.currentTarget.style.transform = pos
                  //       ? "rotate(180deg)"
                  //       : "rotate(0deg)";
                  //     actionElement.style.position = "sticky";
                  //     document
                  //       .querySelectorAll(`.${classes.stickyCell}`)
                  //       .forEach((element) => {
                  //         element.style.position = pos ? "relative" : "sticky";
                  //       });
                  //   }
                  // }}
                  fontSize="small"
                />
            </Box>
            {/* <Box sx={{ display: "flex", alignItems: "center" }}>
              {numSelected > 0 && (
                <ThreeDot
                  onDelete={() => {
                    if (Freeze === 1) {
                      return handleFreeze();
                    }
                    onDelete(true);
                  }}
                />
              )}
            </Box> */}
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function NewItemListPage() {
  const dispatch = useDispatch();

  let today = new Date();
  let yy = today.getFullYear(); 
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;
  const todayDate = yy + "-" + mm + "-" + dd;
  const {
    data: priceList,
    isLoading: isGroupLoading,
    isError,
  } = useListPriceTypesQuery();
  const { data: ledgerList } = useListAccountMasterv2Query();
  let getCompany = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;
  const userPreferenceAndFY = useSelector(
    (state) => state.userPrefrenceandReducer
  );
  const Taxability =
    getCompany?.relatedcompanydetailsnew?.[0].registrationtype === 3
      ? [
        { label: "Composition - Taxable", value: 1 },
        { label: "Exempted", value: 2 },
        { label: "Non-Taxable(Non-GST)", value: 3 },
        { label: "Out of scope", value: 5 },
      ]
      : [
        { label: "Taxable", value: 1 },
        { label: "Exempted", value: 2 },
        { label: "Non-Taxable(Non-GST)", value: 3 },
        { label: "GST Reverse Charge", value: 4 },
        { label: "Out of scope", value: 5 },
      ];
  const { theme } = useThemes();
  const { defaultSortingColumn, defaultSortingOrder } =
    getDefaultSorting("items");
  const classes = useStyles(theme);
  const navigate = useNavigate();
  const [uqcArray, setUQCArray] = useState([]);

  const [purchaseArr, setPurchaseArr] = useState([]);
  const [salesArr, setSalesArr] = useState([]);
  const [allAccountArr, setAllAccountArr] = useState([]);

  const [newUnit, setNewUnit] = useState({ option: "", value: "" });
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [order, setOrder] = useState(defaultSortingOrder);
  const [orderBy, setOrderBy] = useState(defaultSortingColumn);
  const [selected, setSelected] = useState([]);
  const [units, setUnits] = useState([]);
  const [taxableValue, setTaxableValue] = useState("");
  const [registrationType, setRegistrationType] = useState(
    // getCompany?.relatedCompanyDetailsNew?.[0].RegistrationType
    ""
  );
  const [deleteItemModal, setDeleteItemModal] = useState(false);
  const [itemData, setItemData] = useState({});
  const [addEvent, setAddEvent] = useState(false);
  const [page, setPage] = useState(0);
  const [showItems, setShowItems] = useState([]);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [activeValueModal, setActiveValueModal] = useState(); //Inactive confirmation
  const [editData, setEditData] = useState({});
  const [itemID, setItemID] = useState("");
  const [itemTimeStamp, setItemTimeStamp] = useState([]);
  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [ListSelection, setListSelection] = useState("All");
  const [deleteSnackBar, setDeleteSnackBar] = useState(false);
  const [activeRow, setActiveRow] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [mainCategoryId, setMainCategoryId] = useState("");
  const [isFocusItem, setIsFocusItem] = useState(true);
  const [deletedPurchaseRows, setDeletedPurchaseRows] = useState([]);
  const [deletedSalesRows, setDeletedSalesRows] = useState([]);
  const [priceTypeID, setPriceTypeID] = useState("");
  const [showActions,setShowActions] = useState(true)
  const [editable, setEditAble] = useState(false)
  const [params, setParams] = useState({
    id: "",
    view: false,
    salesFlag: 0,
    purchaseFlag: 0,
  });
  const [viewPriceModal, setViewPriceModal] = useState(false);
  const [SummaryData, setSummaryData] = useState({
    open: false,
    description: "",
    lists: [],
  });
  const [priceTypeArr, setPriceTypeArr] = useState([]);
  const [previousID, setPreviousID] = useState("");
  const [sellingPriceRows, setSellingPriceRows] = useState([
    {
      id: 0,
      expiredtimestamp: 0,
      amount: 0,
      DiscountType: 1,
      DiscountValue: 0,
      gstRate: { rate: " ", id: "" },
      cesstype: 1,
      cess: 0,
      amtaftdicount: 0,
      discountAmt: 0,
      priceType: { label: "", value: 0 },
      isActive: 1,
      effectivefrom: todayDate,
      effectiveto: todayDate,
      amountIncludingGst: 0,
      timeStamp: false,
      editable: true,
      new: true,
      order: 1,
      activeType: 1,
      invoiceType: 1,
    },
  ]);

  // useEffect(() => {
  //   const controlAndS = (e) => {
  //     if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "s") {
  //       e.preventDefault();
  //       if (!editable) {
  //         showErrorSnackbar("Nothing to save");

  //       }
  //     }
  //   };

  //   window.addEventListener('keydown', controlAndS);
  //   return () => {
  //     window.removeEventListener('keydown', controlAndS);
  //   };
  // }, [editable]);



  const [filterColumnsMaxValues, setfilterColumnsMaxValues] = useState({
    SalesPriceTo: 0,
    PurchasePriceTo: 0,
  });
  console.log({ filterColumnsMaxValues });
  useEffect(() => {
    API.graphql(
      graphqlOperation(listItemmastersv2, {
        rowfrom: 0,
        limitno: 1,
        columnname: "defaultsellingprice",
        ordertype: "DESC",
        searchmode: 0,
        searcharray: JSON.stringify([]),
      })
    ).then((res) => {
      console.log(res?.data?.listItemmastersv2);
      setfilterColumnsMaxValues((prev) => ({
        ...prev,
        SalesPriceTo: res?.data?.listItemmastersv2?.[0]?.defaultnetsellingprice,
      }));
    });
    API.graphql(
      graphqlOperation(listItemmastersv2, {
        rowfrom: 0,
        limitno: 1,
        columnname: "defaultpurchaseprice",
        ordertype: "DESC",
        searchmode: 0,
        searcharray: JSON.stringify([]),
      })
    ).then((res) => {
      // console.log(res);
      setfilterColumnsMaxValues((prev) => ({
        ...prev,
        PurchasePriceTo:
          res?.data?.listItemmastersv2?.[0]?.defaultnetpurchaseprice,
      }));
    });
    return () => { };
  }, []);

  const defaultFilterColumns = {
    ItemType: "",
    ItemCode: "",
    ItemName: "",
    Category: "",
    Unit: "",hsnsaccode:"",
    ShowInInvoice: "",
    PurchaseAccountName: "",
    SalesAccountName: "",
    TaxabilityCD: "",
    PurchasePriceFrom: "",
    PurchasePriceTo: "",
    SalesPriceFrom: "",
    SalesPriceTo: "",
    Status: "",
    dueDate: "",
    GrantTotalAmount: "",
    BalanceDueAmount: "",
    overDueDays: "",
    CancelFlag: "",
    EntryDateFrom: "",
    EntryDateTo: "",
    SupplierInvoiceDateFrom: "",
    SupplierInvoiceDateTo: "",
  }

  const [filterColumns, setFilterColumns] = useState({
    ...defaultFilterColumns
  });

  const handleResetFilterColumns = (status) => status === false ? setFilterColumns(defaultFilterColumns) : null;
  console.log({ filterColumns });

  const [tempSellingPriceRows, setTempSellingPriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: 0 },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  });
  const [editedSellingPriceRows, setEditedSellingPriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: 0 },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  });
  const [purchasePriceRows, setPurchasePriceRows] = useState([
    {
      id: 0,
      expiredtimestamp: 0,
      amount: 0,
      DiscountType: 1,
      DiscountValue: 0,
      gstRate: { rate: " ", id: "" },
      cesstype: 1,
      cess: 0,
      amtaftdicount: 0,
      discountAmt: 0,
      priceType: { label: "", value: 0 },
      isActive: 1,
      effectivefrom: todayDate,
      effectiveto: "",
      amountIncludingGst: 0,
      timeStamp: false,
      editable: true,
      new: true,
      order: 1,
      activeType: 1,
      invoiceType: 2,
    },
  ]);
  const [tempPurchasePriceRows, setTempPurchasePriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: 0 },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  });
  const [editedPurchasePriceRows, setEditedPurchasePriceRows] = useState({
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: 0 },
    isActive: 1,
    effectivefrom: todayDate,
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  });
  const [rows, setRows] = useState([
    {
      type: 1,
      itemId: "",
      voucherSeries: { label: "", value: "" },
      itemCode: "",
      itemName: "",
      itemCtegorey: 1,
      Unit: "",hsnCode: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
      showItemInv: [],
      purchaseAccount: { label: "", value: "" },
      salesAccount: { label: "", value: "" },
      taxability: { label: "", value: "" },
      updatePrice: "",
      purchaseAmt: 0,
      sellingprice: 0,
      salesTaxableAmt: 0,
      purchaseTaxableAmt: 0,
      registrationType: "",
      purchaseInvoiceFlag: 0,
      salesInvoiceFlag: 0,
      editable: true,
      new: true,
      remarks: "",
    },
  ]);


  const [firstMount, setfirstMount] = useState({ current: true });
  
  const rowsPerPageRef = useRef(rowsPerPage);
  rowsPerPageRef.current = rowsPerPage;
  
  const filterColumnsRef = useRef(filterColumns);
  filterColumnsRef.current = filterColumns;
  
  const debouncedSearchRef = useRef(null);
  useEffect(() => {
    if (firstMount.current) {
      setfirstMount({ current: false });
    }
  }, []);
  const [editedRows, setEditedRows] = useState({
    type: 1,
    itemId: "",
    voucherSeries: { label: "", value: "" },
    itemCode: "",
    itemName: "",
    itemCtegorey: 1,
    Unit: "",hsnCode: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    showItemInv: [],
    purchaseAccount: { label: "", value: "" },
    salesAccount: { label: "", value: "" },
    taxability: { label: "", value: "" },
    updatePrice: "",
    purchaseAmt: 0,
    sellingprice: 0,
    salesTaxableAmt: 0,
    purchaseTaxableAmt: 0,
    registrationType: "",
    purchaseInvoiceFlag: 0,
    salesInvoiceFlag: 0,
    editable: true,
    new: true,
  });
  //leave modal
  const [initialState, setInitialState] = useState({ ...editedRows });
  const newEditedObj = {
    type: 1,
    itemId: "",
    itemName: "",
    itemCtegorey: 1,
    Unit: "",hsnCode: {
      label: '',
      value: '',
      companyID: '',
      hsnID: '',
      codeType: '',
      description: '',
    },
    showItemInv: [],
    purchaseAccount: { label: "", value: "" },
    salesAccount: { label: "", value: "" },
    taxability: { label: "", value: "" },
    updatePrice: "",
    purchaseAmt: 0,
    sellingprice: 0,
    salesTaxableAmt: 0,
    purchaseTaxableAmt: 0,
    registrationType: "",
    purchaseInvoiceFlag: 0,
    salesInvoiceFlag: 0,
    editable: true,
    new: true,
  };
  let saveV = true;
  const newSalesObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: 0 },
    isActive: 1,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 1,
  };
  const newPurchaseObj = {
    id: 0,
    expiredtimestamp: 0,
    amount: 0,
    DiscountType: 1,
    DiscountValue: 0,
    gstRate: { rate: " ", id: "" },
    cesstype: 1,
    cess: 0,
    amtaftdicount: 0,
    discountAmt: 0,
    priceType: { label: "", value: 0 },
    isActive: 1,
    effectivefrom: "",
    effectiveto: "",
    amountIncludingGst: 0,
    timeStamp: false,
    editable: true,
    new: true,
    order: 1,
    activeType: 1,
    invoiceType: 2,
  };
  const [reNavigate, setReNavigate] = useState("");

  function deepEqual(obj1, obj2) {
    if (
      typeof obj1 !== "object" ||
      typeof obj2 !== "object" ||
      obj1 === null ||
      obj2 === null
    ) {
      return obj1 == obj2;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    // Check if all keys and values are the same
    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }

  const [aTags, setATags] = useState(document.getElementsByTagName("a").length);
  let selector = useSelector((state) => state.sidebarReducer?.SideBarOpts);
  let selectorDrawer = useSelector((state) => state.sidebarReducer);
  useEffect(() => {
    setATags(document.getElementsByTagName("a").length);
    setTimeout(() => {
      setATags(document.getElementsByTagName("a").length);
    }, 150);
  }, [selectorDrawer, selector]);

  // useEffect(() => {
  //   if (!deepEqual(editedRows, initialState)) {
  //     if (!modalOpen) {
  //       handleNavigationBlocker(true);
  //     }
  //     return;
  //   }

  //   return () => {
  //     handleNavigationBlocker(false);
  //   };
  // }, [editedRows, aTags]);

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    const shouldBeDirty =
      JSON.stringify(editedRows) !== JSON.stringify(initialState);
    if (shouldBeDirty !== isDirty) {
      setIsDirty(shouldBeDirty);
    }
  }, [editedRows, aTags]);

  useEffect(() => {
    dispatch(setNavigationBlocked(isDirty));
  }, [isDirty, dispatch]);

  let [modalOpen, setModalOpen] = useState(false);

  const handleDeleteClick = (row, ind) => {
    const purchaseFlag = row.purchaseInvoiceFlag;
    const invoiceFlag = row.salesInvoiceFlag;
    let rowData = {
      ...row,
      financialyearid: userPreferenceAndFY?.financialYear?.financialyearid,
      companyid: getCompany?.companyid,
      purchaseaccountid: purchaseFlag === 0 ? 0 : row.purchaseAccount?.value,
      purchaseinvoiceflag: purchaseFlag,
      salesaccountid: invoiceFlag === 0 ? 0 : row.salesAccount?.value,
      salesinvoiceflag: invoiceFlag,
    };
    if (row.itemId == "") {
      setRows(rows.filter((row1) => row1.id !== row.id));
    } else {
      setDeleteItemModal(true);
      setItemData({
        id: row.itemId,
        ind: ind + 1,
        data: rowData,
      });
    }
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    const newSelected = [...rows].map((n) => n.itemId);
    if (event.target.checked && rows.length) {
      setSelected(newSelected);
      return;
    }

    setDeleteSnackBar(false);
    setSelected([]);
  };
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  const Freeze = useSelector(
    (state) => state.userPrefrenceandReducer?.financialYear?.freezestatus
  );
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  const navigate01 = useNavigate();

  const handleAddClick = (event) => {
    if (Freeze == 1) {
      return handleFreeze();
    } else if (saveSkipStatus == false) {
      event.preventDefault();
      navigate01("/companysetup");
      showWarningSnackbar("Please Complete the Company Setup Details");
      dispatch(settingsClose());
    }
    if (addEvent !== true) {
      setEditAble(true)
      setAddEvent(true);
      setItemID("");
      // resetItemRow();
      setEditedRows(newEditedObj);
      setSellingPriceRows([newSalesObj]);
      setPurchasePriceRows([newPurchaseObj]);
      setCategoryId(mainCategoryId);
      setIsFocusItem(true);
      setRegistrationType(
        getCompany?.relatedCompanyDetailsNew?.[0].RegistrationType
      );
      setParams({ id: "", view: false, salesFlag: 0, purchaseFlag: 0 });
      handleResetScroll();
    }
  };
  const [testUnit, settestUnit] = useState();

  const {
    data: unitList,
    isLoading: isUnitListLoading,
    isError: isUnitListError,
  } = useGetCompanyCodeTranslationQuery({ codetype: "UNITS" });

  useEffect(() => {
    settestUnit(listItemDetails());

    return () => { };
  }, [unitList]);
  async function listAccountMasters() {
    try {
      let salesArr = [];
      let purchaseArr = [];
      let all = [];
      const res = { data: { listAccountMasterv2: ledgerList } };
      if (res.data.listAccountMasterv2 !== null) {
        const filteredLedgerList = res.data.listAccountMasterv2.filter(
          (item) =>
            item?.accountsid !== 12 &&
            (companyType !== 1 ||
              (item.accountsid !== 32 &&
                item.accountsid !== 33 &&
                ![2, 4, 5].includes(item.tax_type)))
        );

        filteredLedgerList.map((ele) => {
          let groupName = ele.accountgroupname
            ?.replace(/([a-z])([A-Z])/g, "$1 $2")
            ?.trim();
          all.push({
            label: ele.accountname,
            value: ele.accountsid,
            groupName,
          });
        });

        const filteredPurchaseArray = filteredLedgerList?.filter((item) => {
          return comparePathWithId(item.path, 21, 23);
        });
        filteredPurchaseArray.map((ele) => {
          let groupName = ele.accountgroupname
            ?.replace(/([a-z])([A-Z])/g, "$1 $2")
            ?.trim();
          if (ele.accountsid !== 41) {
            purchaseArr.push({
              label: ele.accountname,
              value: ele.accountsid,
              groupName,
            });
          }
        });
        const filteredSalesArray = filteredLedgerList?.filter((item) => {
          return comparePathWithId(item.path, 19, 22);
        });
        filteredSalesArray.map((ele) => {
          let groupName = ele.accountgroupname
            ?.replace(/([a-z])([A-Z])/g, "$1 $2")
            ?.trim();

          salesArr.push({
            label: ele.accountname,
            value: ele.accountsid,
            groupName,
          });
        });
        let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29];
        let setArrayAll =
          getCompany?.relatedcompanydetailsnew?.[0].registrationtype !== 1
            ? [...all]
            : all.filter((e) => !GSTArrayValues.includes(e.value));
        setAllAccountArr(setArrayAll);
        setSalesArr(salesArr);
        setPurchaseArr(purchaseArr);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  const [EnableSearch, setEnableSearch] = useState(false);

  const DateRangeRef = useRef(null);
  function comparePathWithId(pathString, ...ids) {
    const pathArray = pathString?.replace(/^\/|\/$/g, "").split("/");
    const pathWithoutAccountId = pathArray?.slice(0, -1);

    return ids.some((id) => pathWithoutAccountId?.includes(id.toString()));
  }
  async function listItemDetails() {
    try {
      return;
      let salesArr = [];
      let purchaseArr = [];
      let all = [];
      let itemObj = {};
      let itemArr = [];
      let unitObj = {};
      let cateObj = {};
      let accountObj = {};
      let unitsArray = [];
      let taxableObj = {};
      const showItems = [
        {
          label: "Purchase",
          value: 1,
        },
        {
          label: "Sales",
          value: 2,
        },
      ];
      setShowItems(showItems);
      const [resunits, resx1, resx2, resAccMaster] = await Promise.all([
        API.graphql(
          graphqlOperation(getCompanyCodeTranslation, { codetype: "UNITS" })
        ),
        API.graphql(
          graphqlOperation(listItemCategorymaster, { maincategory: "Goods" })
        ),
        API.graphql(
          graphqlOperation(listItemCategorymaster, { maincategory: "Services" })
        ),
        API.graphql(graphqlOperation(listAccountMasterv2)),
      ]);
      let resCategory = [
        ...resx1.data.listItemCategorymaster,
        ...resx2.data.listItemCategorymaster,
      ];
      Taxability.map((ele) => {
        taxableObj[ele?.value] = ele.label;
      });
      resAccMaster?.data?.listAccountMasterv2.map((ele) => {
        accountObj[ele.accountsid] = ele.accountname;
        all.push({ label: ele.accountname, value: ele.accountsid });
        if (
          (ele.accountgroupid === 21 || ele.accountgroupid === 23) &&
          ele.accountsid !== 41
        ) {
          purchaseArr.push({ label: ele.accountname, value: ele.accountsid });
        }
        if (ele.accountgroupid === 19 || ele.accountgroupid === 22) {
          salesArr.push({ label: ele.accountname, value: ele.accountsid });
        }
      });
      setSalesArr(salesArr);
      setPurchaseArr(purchaseArr);
      let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29];
      let setArrayAll =
        getCompany?.relatedcompanydetailsnew?.[0].registrationtype !== 1
          ? [...all]
          : all.filter((e) => !GSTArrayValues.includes(e.value));
      setAllAccountArr(setArrayAll);
      unitList.map((ele) => {
        unitObj[ele.ID] = ele.codetext;
        if (ele.Is_Active === "1") {
          unitsArray.push({ option: ele.codetext, value: `${ele.ID}` });
        }
      });
      setUQCArray(
        unitList
          .filter((item) => item.UQC !== null)
          .map((element) => {
            return { option: element.UQC, value: `${element.ID}` };
          })
      );
      setUnits(unitsArray);
      resCategory.filter((cate) => {
        cateObj[cate?.itemcategoryid] = cate?.category;
      });
      return [resunits, resx1, resx2, resAccMaster, cateObj];
    } catch (error) {
      console.log("error", error);
    }
  }

  const [limit, setlimit] = useState(rowsPerPage);
  const [circularOpen, setCircularOpen] = useState(true);
  const [dataCount, setdataCount] = useState(0);

  async function listItemDetailsv2(reset, from, to, filterColumn) {
    try {
      if (rows.length / rowsPerPage == page + 1) {
        setlimit(to);
      } else if (rows.length / rowsPerPage < 1) {
        setlimit(rowsPerPage - rows.length);
      }

      setCircularOpen(true);
      if (reset) {
        setRows([]);
        setPage(0);
      }
      let searchMode = 0;
      let SearchArray = [];
      filterColumn = filterColumn ? filterColumn : filterColumns;

      switch (ListSelection) {
        case "Active":
          SearchArray = [...SearchArray, { isactive: 1 }];
          searchMode = 1;
          break;
        case "InActive":
          SearchArray = [...SearchArray, { isactive: 0 }];
          searchMode = 1;
          break;
        default:
          searchMode = 0;
          break;
      }
      // Handle PurchasePriceFrom and PurchasePriceTo together to avoid duplicates
      const purchasePriceFrom = filterColumn.PurchasePriceFrom || '';
      const purchasePriceTo = filterColumn.PurchasePriceTo || '';
      
      if (purchasePriceFrom || purchasePriceTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerPurchasePrice = Number(purchasePriceFrom < purchasePriceTo ? purchasePriceFrom : purchasePriceTo);
        const higherPurchasePrice = Number(purchasePriceFrom < purchasePriceTo ? purchasePriceTo : purchasePriceFrom);
        
        // Add both values with correct order
        SearchArray = [...SearchArray, { purchasepricefrom: lowerPurchasePrice }, { purchasepriceto: higherPurchasePrice }];
      } else if (purchasePriceFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { purchasepricefrom: purchasePriceFrom }];
      } else if (purchasePriceTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { purchasepriceto: purchasePriceTo }];
      }

      // Handle SalesPriceFrom and SalesPriceTo together to avoid duplicates
      const salesPriceFrom = filterColumn.SalesPriceFrom || '';
      const salesPriceTo = filterColumn.SalesPriceTo || '';
      
      if (salesPriceFrom || salesPriceTo) {
        searchMode = 1;
        // Ensure From < To before adding to SearchArray
        const lowerSalesPrice = Number(salesPriceFrom < salesPriceTo ? salesPriceFrom : salesPriceTo);
        const higherSalesPrice = Number(salesPriceFrom < salesPriceTo ? salesPriceTo : salesPriceFrom);
        
        // Add both values with correct order
        SearchArray = [...SearchArray, { salespricefrom: lowerSalesPrice }, { salespriceto: higherSalesPrice }];
      } else if (salesPriceFrom) {
        searchMode = 1;
        SearchArray = [...SearchArray, { salespricefrom: salesPriceFrom }];
      } else if (salesPriceTo) {
        searchMode = 1;
        SearchArray = [...SearchArray, { salespriceto: salesPriceTo }];
      }

      Object.keys(filterColumn).map((key) => {
        if (key == "ShowInInvoice") {
          if (filterColumn[key] == "Purchase") {
            searchMode = 1;
            SearchArray = [...SearchArray, { purchaseinvoiceflag: 1 }];
          } else if (filterColumn[key] == "Sales") {
            searchMode = 1;
            SearchArray = [...SearchArray, { salesinvoiceflag: 1 }];
          }
        } else {
          // Skip PurchasePriceFrom, PurchasePriceTo, SalesPriceFrom, SalesPriceTo as they are handled above
          if (key !== "PurchasePriceFrom" && key !== "PurchasePriceTo" && key !== "SalesPriceFrom" && key !== "SalesPriceTo") {
            if (filterColumn[key]?.toString()?.length > 0) {
              searchMode = 1;
              SearchArray = [
                ...SearchArray,
                { [key?.toLowerCase()]: filterColumn[key] },
              ];
            }
          }
        }
      });
      let itemObj = {};
      let itemArr = [];

      let taxableObj = {};
      Taxability.map((ele) => {
        taxableObj[ele?.value] = ele.label;
      });
      const showItems = [
        {
          label: "Purchase",
          value: 1,
        },
        {
          label: "Sales",
          value: 2,
        },
      ];
      setShowItems(showItems);
      const [res, resCount] = await Promise.all([
        API.graphql(
          graphqlOperation(listItemmastersv2, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy?.toLowerCase(),
            ordertype: order.toUpperCase(),
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
          })
        ),
        API.graphql(
          graphqlOperation(listItemmastersv2Count, {
            rowfrom: from,
            limitno: to,
            columnname: orderBy?.toLowerCase(),
            ordertype: order.toUpperCase(),
            searchmode: searchMode,
            searcharray: JSON.stringify(SearchArray),
          })
        ),
      ]);
      setdataCount(
        resCount.data.listItemmastersv2Count?.[0]?.statuscode == null
          ? resCount.data.listItemmastersv2Count?.[0].itemcount
          : 0
      );
      

      if (res.data.listItemmastersv2.length > 0) {
        res.data.listItemmastersv2.map((itemEle) => {
          // if (itemEle.InvoiceType === 1) {
          let totSalesAmt = 0;
          let totSalesCess = 0;
          let gstSalesAmt = 0;
          let discountSalesAmt = 0;
          let salesAfterDiscount = 0;
          discountSalesAmt =
            itemEle.sellingdiscounttype == 1
              ? (Number(itemEle?.defaultsellingprice) *
                Number(itemEle.sellingdiscountvalue)) /
              100
              : Number(itemEle.sellingdiscountvalue);
          salesAfterDiscount =
            Number(itemEle?.defaultsellingprice) - Number(discountSalesAmt);
          if (itemEle.taxabilitycd == 4) {
            totSalesCess = 0;
            gstSalesAmt = 0;
          } else {
            totSalesCess =
              itemEle.sellinggstcompensationtype == 1
                ? (Number(salesAfterDiscount) *
                  Number(itemEle?.sellinggstcompensationvalue)) /
                100
                : Number(itemEle?.sellinggstcompensationvalue);
            gstSalesAmt =
              (Number(salesAfterDiscount) * Number(itemEle?.sellinggstrate)) /
              100;
              gstSalesAmt=Number(gstSalesAmt)>0?gstSalesAmt:0;
          }
          totSalesAmt =
            Number(itemEle?.defaultsellingprice) -
            Number(discountSalesAmt) +
            Number(gstSalesAmt) +
            Number(totSalesCess);

          itemEle.salesamt = totSalesAmt;
          itemEle.salesnetamt = totSalesAmt;
          itemEle.salestaxableamt =
            Number(itemEle?.defaultsellingprice) - Number(discountSalesAmt);

          // }
          // if (itemEle.InvoiceType === 2) {
          let totPurchaseAmt = 0;
          let totpurchaseCess = 0;
          let gstPurchaseAmt = 0;
          let discountPurchaseAmt = 0;
          let purchaseAfterDiscount = 0;
          discountPurchaseAmt =
            itemEle?.purchasediscounttype == 1
              ? (Number(itemEle?.defaultpurchaseprice) *
                Number(itemEle?.purchasediscountvalue)) /
              100
              : Number(itemEle?.purchasediscountvalue);
          purchaseAfterDiscount =
            Number(itemEle?.defaultpurchaseprice) - Number(discountPurchaseAmt);
          totpurchaseCess =
            itemEle?.purchasegstcompensationtype == 1
              ? (Number(purchaseAfterDiscount) *
                Number(itemEle?.purchasegstcompensationvalue)) /
              100
              : Number(itemEle?.purchasegstcompensationvalue);
          gstPurchaseAmt =
            (Number(purchaseAfterDiscount) * Number(itemEle?.purchasegstrate)) /
            100;
            gstPurchaseAmt =
            Number(gstPurchaseAmt)>0?gstPurchaseAmt:0 ;
          totPurchaseAmt =
            Number(itemEle?.defaultpurchaseprice) -
            Number(discountPurchaseAmt) +
            Number(gstPurchaseAmt) +
            Number(totpurchaseCess);
          itemEle.purchaseamt = totPurchaseAmt;
          itemEle.purchasenetamt = totPurchaseAmt;
          itemEle.purchasetaxableamt =
            Number(itemEle?.defaultpurchaseprice) - Number(discountPurchaseAmt);
          // }
          let purchaseAccount,
            salesAccount,
            unitObj,
            taxability,
            categoryObj = { label: "", value: "" },hsnObj= {
              label: '',
              value: '',
              companyID: '',
              hsnID: '',
              codeType: '',
              description: '',
            }

          purchaseAccount =
            itemEle.purchaseaccountid == 0
              ? ""
              : {
                label: itemEle.purchaseaccountname,
                value: itemEle.purchaseaccountid,
              };
          salesAccount =
            itemEle.salesaccountid == 0
              ? ""
              : {
                label: itemEle?.salesaccountname,
                value: itemEle?.salesaccountid,
              };
          taxability = {
            label: taxableObj[itemEle?.taxabilitycd],
            value: itemEle?.taxabilitycd,
          };
          categoryObj =
            itemEle.itemcategorycd === "0"
              ? itemEle.itemtype === "GOODS"
                ? { label: "Goods", value: "1" }
                : { label: "Services", value: "2" }
              : { label: itemEle.itemcategory, value: itemEle?.itemcategorycd };

          unitObj = { label: itemEle?.codetext, value: itemEle?.measurementcd };
          if (itemEle.hsnsaccode !== null) {
            hsnObj={
              
              label: `${itemEle.hsnsaccode} - ${itemEle.hsndescription}`,
              value: `${itemEle.hsnsaccode}`,
              companyID: itemEle.companyid,
              hsnID: itemEle.hsnsacid,
              codetype: itemEle.hsncodetype,
              description: itemEle.hsndescription,
            }
          }
          itemObj = {
            purchaseAccount,
            salesAccount,
            unitObj,
            hsnObj,
            taxability,
            categoryObj,
            itemId: itemEle.itemid,
            timeStamp: itemEle?.enteredtimestamp,
            type: itemEle.itemtype === "GOODS" ? 1 : 2,
            itemCode: itemEle.itemcode,
            itemName: itemEle.itemname,
            itemCtegorey:
              itemEle?.itemcategorycd === "0"
                ? itemEle?.itemtype === "GOODS"
                  ? "1"
                  : "2"
                : itemEle?.itemcategorycd,
            unit: itemEle?.measurementcd,
            hsnCode:hsnObj,
            showItemInv:
              itemEle?.purchaseinvoiceflag === 1 &&
                itemEle?.salesinvoiceflag === 0
                ? [{ label: "Purchase", value: 1 }]
                : itemEle?.salesinvoiceflag === 1 &&
                  itemEle?.purchaseinvoiceflag === 0
                  ? [{ label: "Sales", value: 2 }]
                  : itemEle?.purchaseinvoiceflag === 1 &&
                    itemEle?.salesinvoiceflag === 1
                    ? [
                      { label: "Purchase", value: 1 },
                      { label: "Sales", value: 2 },
                    ]
                    : [],
            showItemString:
              itemEle?.purchaseinvoiceflag === 1 &&
                itemEle?.salesinvoiceflag === 0
                ? ["Purchase"]
                : itemEle?.salesinvoiceflag === 1 &&
                  itemEle?.purchaseinvoiceflag === 0
                  ? ["Sales"]
                  : itemEle?.purchaseinvoiceflag === 1 &&
                    itemEle?.salesinvoiceflag === 1
                    ? ["Purchase", "Sales"]
                    : [],

            registrationType:
              itemEle?.taxabilitycd != 1 && itemEle?.taxabilitycd != 4 ? 1 : "",
            salesInvoiceFlag: itemEle.salesinvoiceflag,
            purchaseInvoiceFlag: itemEle.purchaseinvoiceflag,
            purchaseAmt: itemEle?.purchaseamt,
            purchaseTaxableAmt: itemEle?.purchasetaxableamt,
            salesTaxableAmt: itemEle?.salestaxableamt,
            sellingprice: itemEle?.salesamt,
            // salesNetAmt: itemEle?.salesnetamt,
            salesNetAmt:companyType===3?itemEle?.salesTaxableAmt: itemEle?.salesnetamt,
            purchaseNetAmt: itemEle?.purchasenetamt,
            voucherSeries: {
              label: itemEle?.serialnumber,
              value: itemEle?.serialnumber,
            },
            editable: false,
            new: false,
            Is_Active: itemEle?.is_active,
            description: itemEle?.description?.split("**")
          };
          itemArr.push(itemObj);
        });
       

        const sortedArray = [...itemArr];
        if (reset) {
          setRows((prev) => [...sortedArray]);
        } else {
          setRows((prev) => [...prev, ...sortedArray]);
        }
        // setEditedRows({});
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setCircularOpen(false);
    }
  }
  async function listPriceDetails() {
    try {
      // const res = await API.graphql(graphqlOperation(listPriceType));
      let priceTypArr = [];
      if (priceList !== null) {
        priceList.map((ele) => {
          priceTypArr.push({ label: ele.pricetype, value: ele.id });
        });
        setPriceTypeArr(priceTypArr);
      }
    } catch (e) {
      console.log(e);
    }
  }

  async function updateList(datas, status) {
    try {
      const [resItem] = await Promise.all([
        API.graphql(
          graphqlOperation(listItemmastersv2, {
            rowfrom: 0,
            limitno: 1,
            columnname: "EnteredTimeStamp",
            ordertype: order.toUpperCase(),
            searchmode: 0,
            searcharray: JSON.stringify([]),
          })
        ),
      ]);

      setFilterColumns({
        ItemType: "",
        ItemCode: "",
        ItemName: "",
        Category: "",
        Unit: "",hsnsaccode:"",
        ShowInInvoice: "",
        PurchaseAccountName: "",
        SalesAccountName: "",
        TaxabilityCD: "",
        PurchasePriceFrom: "",
        PurchasePriceTo: "",
        SalesPriceFrom: "",
        SalesPriceTo: "",
        Status: "",
        dueDate: "",
        GrantTotalAmount: "",
        BalanceDueAmount: "",
        overDueDays: "",
        CancelFlag: "",
        EntryDateFrom: "",
        EntryDateTo: "",
        SupplierInvoiceDateFrom: "",
        SupplierInvoiceDateTo: "",
      });

      let res = { data: { listItemmastersv2: [datas] } };
      console.log(res, datas);

      let itemObj = {};
      let itemArr = [];

      let taxableObj = {};
      Taxability.map((ele) => {
        taxableObj[ele?.value] = ele.label;
      });
      const showItems = [
        {
          label: "Purchase",
          value: 1,
        },
        {
          label: "Sales",
          value: 2,
        },
      ];
      setShowItems(showItems);

      console.log("resItem", resItem);

      if (resItem.data.listItemmastersv2.length > 0) {
        resItem.data.listItemmastersv2.map((itemEle) => {
          // if (itemEle.InvoiceType === 1) {
          let totSalesAmt = 0;
          let totSalesCess = 0;
          let gstSalesAmt = 0;
          let discountSalesAmt = 0;
          let salesAfterDiscount = 0;
          discountSalesAmt =
            itemEle.sellingdiscounttype == 1
              ? (Number(itemEle?.defaultsellingprice) *
                Number(itemEle.sellingdiscountvalue)) /
              100
              : Number(itemEle.sellingdiscountvalue);
          salesAfterDiscount =
            Number(itemEle?.defaultsellingprice) - Number(discountSalesAmt);
          totSalesCess =
            itemEle.sellinggstcompensationtype == 1
              ? (Number(salesAfterDiscount) *
                Number(itemEle?.sellinggstcompensationvalue)) /
              100
              : Number(itemEle?.sellinggstcompensationvalue);
          gstSalesAmt =
            (Number(salesAfterDiscount) * Number(itemEle?.sellinggstrate)) /
            100;
            gstSalesAmt =
            Number(gstSalesAmt)>0?gstSalesAmt:0;
          totSalesAmt =
            Number(itemEle?.defaultsellingprice) -
            Number(discountSalesAmt) +
            Number(gstSalesAmt) +
            Number(totSalesCess);

          itemEle.salesAmt = totSalesAmt;
          itemEle.salesNetAmt = totSalesAmt;
          itemEle.salesTaxableAmt =
            Number(itemEle?.defaultsellingprice) - Number(discountSalesAmt);

          // }
          // if (itemEle.InvoiceType === 2) {
          let totPurchaseAmt = 0;
          let totpurchaseCess = 0;
          let gstPurchaseAmt = 0;
          let discountPurchaseAmt = 0;
          let purchaseAfterDiscount = 0;
          discountPurchaseAmt =
            itemEle?.purchasediscounttype == 1
              ? (Number(itemEle?.defaultpurchaseprice) *
                Number(itemEle?.purchasediscountvalue)) /
              100
              : Number(itemEle?.purchasediscountvalue);
          purchaseAfterDiscount =
            Number(itemEle?.defaultpurchaseprice) - Number(discountPurchaseAmt);
          totpurchaseCess =
            itemEle?.purchasegstcompensationtype == 1
              ? (Number(purchaseAfterDiscount) *
                Number(itemEle?.purchasegstcompensationvalue)) /
              100
              : Number(itemEle?.purchasegstcompensationvalue);
          gstPurchaseAmt =
            (Number(purchaseAfterDiscount) * Number(itemEle?.purchasegstrate)) /
            100;
              gstPurchaseAmt =
            Number(gstPurchaseAmt)>0?gstPurchaseAmt:0;
          totPurchaseAmt =
            Number(itemEle?.defaultpurchaseprice) -
            Number(discountPurchaseAmt) +
            Number(gstPurchaseAmt) +
            Number(totpurchaseCess);
          itemEle.purchaseAmt = totPurchaseAmt;
          itemEle.purchaseNetAmt = totPurchaseAmt;
          itemEle.purchaseTaxableAmt =
            Number(itemEle?.defaultpurchaseprice) - Number(discountPurchaseAmt);
          // }

          let purchaseAccount,
            salesAccount,
            unitObj,
            taxability,
            categoryObj = { label: "", value: "" },hsnObj= {
              label: '',
              value: '',
              companyID: '',
              hsnID: '',
              codeType: '',
              description: '',
            };

          if (isPromise(testUnit)) {
            purchaseAccount =
              itemEle.purchaseaccountid == 0
                ? ""
                : {
                  label: itemEle?.purchaseaccountname,
                  value: itemEle?.purchaseaccountid,
                };
            salesAccount =
              itemEle.salesaccountid == 0
                ? ""
                : {
                  label: itemEle?.salesaccountname,
                  value: itemEle?.salesaccountid,
                };
            taxability = {
              label: taxableObj[itemEle?.taxabilitycd],
              value: itemEle?.taxabilitycd,
            };
            categoryObj =
              itemEle.itemcategorycd === "0"
                ? itemEle.itemtype === "GOODS"
                  ? "Goods"
                  : "Services"
                : itemEle?.itemcategory;

            unitObj = itemEle?.codetext;
          }
          if (itemEle.hsnsaccode !== null) {
          hsnObj={
            
            label: `${itemEle.hsnsaccode} - ${itemEle.hsndescription}`,
            value: `${itemEle.hsnsaccode}`,
            companyID: itemEle.companyid,
            hsnID: itemEle.hsnsacid,
            codetype: itemEle.hsncodetype,
            description: itemEle.hsndescription,
          }
        }
          itemObj = {
            purchaseAccount,
            salesAccount,
            unitObj,
            hsnObj,
            taxability,
            categoryObj,
            itemId: itemEle.itemid,
            timeStamp: itemEle?.enteredtimestamp,
            type: itemEle.itemtype === "GOODS" ? 1 : 2,
            itemCode: itemEle.itemcode,
            itemName: itemEle.itemname,
            itemCtegorey:
              itemEle?.itemcategorycd === "0"
                ? itemEle?.itemtype === "GOODS"
                  ? "1"
                  : "2"
                : itemEle?.itemcategorycd,
            unit: itemEle?.measurementcd,
            hsnCode:hsnObj,
            showItemInv:
              itemEle?.purchaseinvoiceflag === 1 &&
                itemEle?.salesinvoiceflag === 0
                ? [{ label: "Purchase", value: 1 }]
                : itemEle?.salesinvoiceflag === 1 &&
                  itemEle?.purchaseinvoiceflag === 0
                  ? [{ label: "Sales", value: 2 }]
                  : itemEle?.purchaseinvoiceflag === 1 &&
                    itemEle?.salesinvoiceflag === 1
                    ? [
                      { label: "Purchase", value: 1 },
                      { label: "Sales", value: 2 },
                    ]
                    : [],
            showItemString:
              itemEle?.purchaseinvoiceflag === 1 &&
                itemEle?.salesinvoiceflag === 0
                ? ["Purchase"]
                : itemEle?.salesinvoiceflag === 1 &&
                  itemEle?.purchaseinvoiceflag === 0
                  ? ["Sales"]
                  : itemEle?.purchaseinvoiceflag === 1 &&
                    itemEle?.salesinvoiceflag === 1
                    ? ["Purchase", "Sales"]
                    : [],

            registrationType:
              itemEle?.taxabilitycd != 1 && itemEle?.taxabilitycd != 4 ? 1 : "",
            salesInvoiceFlag: itemEle.salesinvoiceflag,
            purchaseInvoiceFlag: itemEle.purchaseinvoiceflag,
            purchaseAmt: itemEle?.purchaseAmt,
            purchaseTaxableAmt: itemEle?.purchaseTaxableAmt,
            salesTaxableAmt: itemEle?.salesTaxableAmt,
            sellingprice: itemEle?.salesAmt,
            // salesNetAmt: itemEle?.salesNetAmt,
             salesNetAmt:companyType===3?itemEle?.salesTaxableAmt: itemEle?.salesnetamt,
            purchaseNetAmt: itemEle?.purchaseNetAmt,
            voucherSeries: {
              label: itemEle?.SerialNumber,
              value: itemEle?.SerialNumber,
            },
            editable: false,
            new: false,
            Is_Active: itemEle?.is_active,
            description: itemEle?.description?.split("**")
          };
          itemArr.push(itemObj);
        });
        const sortedArray = [...itemArr];

        if (status) {
          setRows((prev) => [...sortedArray, ...prev]);
          setdataCount((prev) => prev + 1);
        } else {
          let index = rows.findIndex(
            (elem) => elem.itemId == resItem.data.listItemmastersv2[0].itemid
          );
          // let temprows = JSON.parse(JSON.stringify(rows));
          // temprows[index] = sortedArray[0];
          // setRows((prev) => [...temprows]);
          if (index !== -1) {
            const updatedRows = JSON.parse(JSON.stringify(rows));
            updatedRows[index] = itemArr[0]; // Replace with the new data
            setRows(updatedRows);
          }
        }

        // setEditedRows({});
        setTempSellingPriceRows(newSalesObj);
        setEditedSellingPriceRows(newSalesObj);
        setEditedPurchasePriceRows(newPurchaseObj);
        setTempPurchasePriceRows(newPurchaseObj);
        setPurchasePriceRows([newPurchaseObj]);
        setSellingPriceRows([newSalesObj]);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setCircularOpen(false);
    }
  }

  const handleChangePage = (event, newPage) => {
    if (circularOpen) return;
    console.log(event, newPage);
    if (newPage > page) {
      console.log(newPage);
      if (rows.length < rowsPerPage * (newPage + 1)) {
        listItemDetailsv2(
          false,
          rows.length,
          Math.abs(rowsPerPage * (newPage + 1) - rows.length)
        );
      }
    }
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    if (circularOpen) return;

    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const isSelected = (name) => selected.indexOf(name) !== -1;
  let search = (obj) => {
    console.log(obj);
    listItemDetailsv2(true, 0, rowsPerPageRef.current, obj);
  };
  
  useEffect(() => {
    if (!debouncedSearchRef.current) {
      debouncedSearchRef.current = createDebouncedCallback(
        (obj) => {
          let searchFlag = false;
          if (
            Object.keys(filterColumnsRef.current).map((key) => {
              if (filterColumnsRef.current[key]?.toString()?.length > 0) {
                searchFlag = true;
              }
            })
          )
          if (searchFlag) {
            search(obj);
          } else {
            listItemDetailsv2(true, 0, rowsPerPageRef.current);
          }
        },
        500
      );
    }
  }, []);
  
  const filterSearch = useCallback((obj) => {
    debouncedSearchRef.current(obj);
  }, []);
  useEffect(() => {
    if (firstMount.current === false) {
      filterSearch(filterColumns);
      setSelected([]);
    }

    return () => { };
  }, [filterColumns, filterSearch, ListSelection]);

  useEffect(() => {
    console.log(rowsPerPage, rows.length);
    if (firstMount.current === false) {
      if (rowsPerPage > rows.length) {
        console.log(rowsPerPage, rows.length);
        listItemDetailsv2(true, 0, rowsPerPageRef.current);
      } else {
        console.log(rowsPerPage, rows.length);
      }
    }
    return () => { };
  }, [rowsPerPage]);

  async function getCompanyDetails() {
    try {
      if (getCompany !== null) {
        setRegistrationType(
          getCompany?.relatedCompanyDetailsNew?.[0].RegistrationType
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    getCompanyDetails();
  }, []);
  useEffect(() => {
    listAccountMasters();
  }, [ledgerList]);

  let updateListing = async () => {
    await listItemDetailsv2(true, 0, rowsPerPageRef.current);
    let col = editedRows;
    if (col.Is_Active == 1) {
      setAddEvent(false);
      if (
        (col?.taxability?.value != 1 && col?.taxability?.value != 4) ||
        getCompany?.relatedcompanydetailsnew?.[0].registrationtype == 1
      ) {
        col.purchaseAmt = Number(col.purchaseTaxableAmt);
        col.sellingprice = Number(col.salesTaxableAmt);
        setRegistrationType(1);
      } else {
        col.purchaseAmt = Number(col.purchaseNetAmt);
        col.sellingprice =companyType===3?Number(col?.salesTaxableAmt): Number(col.salesNetAmt);
        setRegistrationType("");
      }
      setCategoryId(col.itemCtegorey);
      setEditedRows(col);
      setItemID(col.itemId);
      setItemTimeStamp(col?.timeStamp);
      let arr = [...rows];
      let tempArr = arr.filter((ele, index) => {
        if (ele.new !== true) {
          if (ele.itemId == col.itemId) {
            ele.editable = true;
            ele.new = false;
          } else {
            ele.editable = false;
            ele.new = false;
          }
          return ele;
        }
      });
      setRows(tempArr);
    }
  };
  useEffect(() => {
    setRows([]);
    setPage(0);
    updateListing();
    return () => { };
  }, [order, orderBy]);

  const handleFilterBySearch = (event, name, value) => {
    setPage(0);
    let query = value ? value : event.target?.value;
    const obj = { ...filterColumns };
    if (name == "PurchasePrice") {
      obj["PurchasePriceFrom"] = query[0];
      obj["PurchasePriceTo"] = query[1];
    } else if (name == "SalesPrice") {
      obj["SalesPriceFrom"] = query[0];
      obj["SalesPriceTo"] = query[1];
    } else {
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        } else {
          // obj[key] = "";
        }
      }
    }

    console.log(obj);
    setFilterColumns(obj);
  };

  const tableContainerRef = useRef(null);

  const handleResetScroll = () => {
    if (tableContainerRef.current) {
      tableContainerRef.current.scrollLeft = 0;
    }
  };

  const handleCellClick = (col) => {
    dispatch(
      updateTitle(JSON.stringify({ type: col.type, name: col.itemName }))
    ); //itemName,itemCode any
    navigate("/viewitem", {
      state: {
        id: col.itemId,
        view: true,
        type: col.type,
        taxType: col?.taxability?.value,
      },
    });
  };

  const handleClickBox = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  // Click handler to close the popover
  const handleClose = () => {
    setAnchorEl(null);
  };

  // State to manage the anchor element for the popover
  const [anchorEl, setAnchorEl] = useState(null);

  const [exportItem, setExportItem] = useState(null);

  const [exportModalOpen, setExportModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  // Options to display in the popover, each with a label and onClick handler
  const options = [
    // {
    //   label: "Import",
    //   icon: <CloudDownloadIcon sx={{color : "blue"}}/>,
    //   onClick: () => {
    //     navigate("/import-data");
    //   },
    //   link: "/import-data",
    //   rollingOutSoon:"true"
    // },
    {
      label: "Export",
      icon: <CloudUploadIcon sx={{color : "#ffa500"}}/>,
      onClick: () => {
        if (rows.length > 0) {
          setExportModalOpen(true);
          setExportItem("Goods");
        } else {
          showWarningSnackbar("No data available for export.");
        }
      },
      link: "",
      rollingOutSoon:"true"
    },
  ];
  useEffect(() => {
    listPriceDetails();
  }, [priceList]);
    const [rolling,setRolling] = useState(false)
  return (
    <Box>
      <Box
        sx={{
          // backgroundColor: theme.palette.bodyGray.secondary,
          borderRadius: "15px",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderTopRightRadius: "12px",
            borderTopLeftRadius: "12px",
            padding: "8px 10px",
            backgroundColor: "primary.main",

          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              flex: { xs: 1, sm: 1 },
              justifyContent: "space-between",
            }}
          > */}
          <LinkList add="Add Item" name="item" handleClick={handleAddClick} />

          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TableSearchButton setEnableSearch={setEnableSearch} EnableSearch={EnableSearch} id={"goodsSearch"} onClick={handleResetFilterColumns} />

            <Box
              sx={{
                display: {
                  xs: "none",
                  sm: "flex",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                  color: "white",
                }}
              >
                Total : {dataCount} Item{dataCount !== 1 && "s"}{" "}
                {selected.length != 0
                  ? `(Selected Item: ${selected.length}/${dataCount})`
                  : ""}
              </Typography>
              <Box sx={{}}>
                <DropDownForListing
                  name={"ser"}
                  list={[
                    { label: "All", value: "All" },
                    { label: "Active", value: "Active" },
                    { label: "In-Active", value: "InActive" },
                  ]}
                  value={ListSelection}
                  onChange={(e) => {
                    setListSelection(e.target.value);
                  }}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid transparent",
                  borderRadius: "5px",
                  p: 1,
                  cursor: "pointer",
                  "&:hover": {
                    borderColor: "#ccc",
                    backgroundColor: theme.palette.input.border || "#f5f5f5",
                  },
                }}
                onClick={handleClickBox} // Toggle the popover on box click
              >
                <MoreVert sx={{ fontSize: "20px", color: "#fff" }} />

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <Box sx={{ p: 1,minWidth:"200px" }}>
                    {
                        options.map((option,index) => 
                          option.rollingOutSoon ? 
                          (
                            <Typography
                              key={index}
                              onClick={() => {
                                handleClose();
                              }}
                              sx={{
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                // '&:hover': {
                                //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                                // },
                              }}
                            >
                          <Tooltip 
                            title={<RollingSoon />}
                            placement="right"
                            PopperProps={{
                              sx: {
                                '& .MuiTooltip-tooltip': {
                                  backgroundColor: 'transparent',
                                  boxShadow: 'none',
                                  padding: 0,
                                } 
                              }
                            }}
                          >      
                            <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                }}
                              >
                                {option.icon}
                                <span style={{ marginLeft: '8px', opacity: 0.5 }}>
                                  {option.label}
                                </span>
                            </Box>
                          </Tooltip> 
                            </Typography>
                          ): 
                          (<Link style={{ textDecoration: 'none', color: 'inherit' }} to={option.link} state={{ fromLink: '/customerList' }}>
                              <Typography
                                key={index}
                                onClick={() => {
                                  handleClose();
                                  option.onClick();
                                }}
                                sx={{
                                  cursor: 'pointer',
                                  padding: '8px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  // '&:hover': {
                                  //   backgroundColor: theme.palette.input.border || '#f5f5f5',
                                  // },
                                }}
                              >
                                {option.icon}
                                <span style={{ marginLeft: '8px' }}>{option.label}</span>
                              </Typography>
                          </Link>)
                        )
                      }
                  </Box>
                </Popover>
              </Box>
              {/* </Box> */}
            </Box>
          </Box>


        </Box>
        {console.log(filterColumns, "filter")}
        <Box sx={{ width: "100%" }}>
          <TableContainer
            ref={tableContainerRef}
            id="EntryTable"
            className="custom-scrollbar"
            sx={{
              height: {
                sm: "calc( 100vh - 230px )",
                xs: "calc( 100vh - 180px )",
              },
              // backgroundColor:"white"
            }}
          >
            <Table stickyHeader>
              <EnhancedTableHead
                classes={classes}
                EnableSearch={EnableSearch}
                setEnableSearch={setEnableSearch}
                key={"hgfhtr"}
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={dataCount || 0}
                onDelete={() => setDeleteSelectedModal(true)}
                setFilteredList={setRows}
                roughList={rows}
                data={editedRows}
                visiblerowlength={rows.length}
                required={addEvent}
                setShowActions = {setShowActions}
                showActions = {showActions}
              />

              <TableBody>
                <TableRow
                  className="noTableCellBorder"
                  sx={{
                    ".MuiTableCell-root": {
                      backgroundColor: "transparent ",
                      padding: "1px 15px",
                    },
                    ".css-wrnu0i-MuiInputBase-root": {
                      fontSize: "12px",
                    },
                    ".css-xk0adg-MuiButtonBase-root-MuiIconButton-root": {
                      padding: "2px 4px",
                    },
                    ".css-1gqfvv-MuiPaper-root": {
                      boxShadow: "none",
                      borderBottom: "solid 1px rgba(0,0,0,0.24)",
                      borderRadius: "0px",
                    },
                    visibility: !EnableSearch ? "collapse" : "visible",
                    // EnableSearch? { "display": "none"}:""
                  }}
                >
                  <TableCell></TableCell>

                  <TableCell >
                    <Paper
                      id="goodsSearch"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width:EnableSearch? "100%":"50px",
                      }}
                    >
                      <Autocomplete
                        id={""}
                        disableClearable
                        options={["GOODS", "SERVICE"]}
                        isOptionEqualToValue={(option, value) =>
                          option == value
                        }
                        clearIcon={
                          filterColumns.ItemType !== "" ? (
                            <ClearIcon style={{ fontSize: "20px" }} />
                          ) : null
                        }
                        value={filterColumns.ItemType}
                        // onChange={onChange}
                        onChange={(e, value) =>
                          handleFilterBySearch(e, "ItemType", value)
                        }
                        size="small"
                        sx={{ height: "32px" }}
                        renderOption={(props, option) => (
                          <>
                            <MenuItem {...props} key={option} value={option} >
                              <ListItemText primary={option} />
                            </MenuItem>
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField

                            sx={{

                              minWidth: "100px",
                              border: "none", // Ensure border is removed
                              "& .MuiInput-underline:before": {
                                borderBottom: "none", // Remove underline in standard variant
                              },
                              "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                              {
                                borderBottom: "none", // Remove hover effect
                              },
                              "& .MuiInput-underline:after": {
                                borderBottom: "none", // Remove underline for focused state
                              },
                              "& fieldset": { border: "none" },
                            }}
                            placeholder={"Search"}
                            variant="standard"
                            // onFocus={(e) => {
                            //   // When the input is focused, change the label to empty
                            //   e.target.placeholder = ""; // Remove placeholder text on focus if needed
                            // }}
                            // onBlur={(e) => {
                            //   // When the input loses focus, revert changes if necessary
                            //   e.target.placeholder = filterColumns.ItemType
                            //     ? ""
                            //     : "Search"; // Revert placeholder text on blur if needed
                            // }}
                            {...params}
                          />
                        )}
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.ItemType !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                ItemType: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  {/* <TableCell></TableCell> */}

                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="ItemCode"
                        value={filterColumns.ItemCode}
                        onChange={(e) => handleFilterBySearch(e, "ItemCode")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.ItemCode !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                ItemCode: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="ItemName"
                        value={filterColumns.ItemName}
                        onChange={(e) => handleFilterBySearch(e, "ItemName")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.ItemName !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                ItemName: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="Category"
                        value={filterColumns.Category}
                        onChange={(e) => handleFilterBySearch(e, "Category")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.Category !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                Category: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "80px",
                      }}
                    >
                      <InputBase
                        name="Unit"
                        value={filterColumns.Unit}
                        onChange={(e) => handleFilterBySearch(e, "Unit")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.Unit !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                Unit: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  {companyType!==1 &&(
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "80px",
                      }}
                    >
                      <InputBase
                        name="hsnsaccode"
                        value={filterColumns.hsnsaccode}
                        onChange={(e) => handleFilterBySearch(e, "hsnsaccode")}
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.hsnsaccode !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                hsnsaccode: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>)}
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Autocomplete
                        id={""}
                        disableClearable
                        options={["Purchase", "Sales"]}
                        isOptionEqualToValue={(option, value) =>
                          option == value
                        }
                        clearIcon={
                          filterColumns.ShowInInvoice !== "" ? (
                            <ClearIcon style={{ fontSize: "20px" }} />
                          ) : null
                        }
                        value={filterColumns.ShowInInvoice}
                        // onChange={onChange}
                        onChange={(e, value) =>
                          handleFilterBySearch(e, "ShowInInvoice", value)
                        }
                        size="small"
                        sx={{ height: "32px", flex: 1 }}
                        renderOption={(props, option) => (
                          <>
                            <MenuItem {...props} key={option} value={option}>
                              <ListItemText primary={option} />
                            </MenuItem>
                          </>
                        )}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              // mt: filterColumns.ShowInInvoice
                              //   ? "10px"
                              //   : "-14px",
                              ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                              {
                                padding: "8.5px 7px",
                              },
                              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                              {
                                fontSize: "14px",
                              },
                              label: {
                                fontSize: "14px",
                              },
                              ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                              {
                                fontSize: "14px",
                              },
                              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                border: "none", // Ensure border is removed
                              },
                              ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                              {
                                color: "input.font",
                              },
                              ".css-14qz1ij-MuiListItemText-root": {
                                margin: "0px",
                              },
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                              minWidth: "100px",
                              border: "none", // Ensure border is removed
                              "& .MuiInput-underline:before": {
                                borderBottom: "none", // Remove underline in standard variant
                              },
                              "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                              {
                                borderBottom: "none", // Remove hover effect
                              },
                              "& .MuiInput-underline:after": {
                                borderBottom: "none", // Remove underline for focused state
                              },
                            }}
                            placeholder={"Search"}
                            variant="standard"
                            {...params}
                          />
                        )}
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.ShowInInvoice !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                ShowInInvoice: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="PurchaseAccount"
                        value={filterColumns.PurchaseAccountName}
                        onChange={(e) =>
                          handleFilterBySearch(e, "PurchaseAccountName")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.PurchaseAccountName !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                PurchaseAccountName: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <InputBase
                        name="SalesAccount"
                        value={filterColumns.SalesAccountName}
                        onChange={(e) =>
                          handleFilterBySearch(e, "SalesAccountName")
                        }
                        sx={{ flex: 1 }}
                        placeholder="Search"
                        autoComplete="off"
                      />
                      <IconButton type="button" sx={{ p: "0px" }}>
                        {filterColumns.SalesAccountName !== "" ? (
                          <Clear
                            fontSize="small"
                            onClick={() => {
                              setFilterColumns((prev) => ({
                                ...prev,
                                SalesAccountName: "",
                              }));
                            }}
                          />
                        ) : (
                          <SearchIcon fontSize="small" />
                        )}
                      </IconButton>
                    </Paper>
                  </TableCell>
                  {getCompany?.relatedcompanydetailsnew?.[0].registrationtype !=
                    1 && (
                      <TableCell>
                        <Paper
                          sx={{
                            p: "2px 4px",
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Autocomplete
                            id={""}
                            disableClearable
                            options={Taxability}
                            isOptionEqualToValue={(option, value) => {
                              console.log({ option, value });
                              return option.value == value;
                            }}
                            value={
                              Taxability.find(
                                (option) =>
                                  option.value === filterColumns.TaxabilityCD
                              ) || null
                            } // Map value to object
                            getOptionLabel={(option) => option.label}
                            clearIcon={
                              filterColumns.TaxabilityCD !== "" ? (
                                <ClearIcon style={{ fontSize: "20px" }} />
                              ) : null
                            }
                            size="small"
                            onChange={(e, value) => {
                              console.log(value);
                              handleFilterBySearch(
                                e,
                                "TaxabilityCD",
                                value?.value || null
                              );
                              {
                                /* Handle null gracefully */
                              }
                            }}
                            sx={{ height: "32px", width: "200px" }}
                            renderOption={(props, option) => (
                              <MenuItem
                                {...props}
                                key={option.value}
                                value={option.value}
                              >
                                <ListItemText primary={option.label} />
                              </MenuItem>
                            )}
                            renderInput={(params) => (
                              <TextField
                                sx={{
                                  // mt: filterColumns.TaxabilityCD ? "10px" : "-14px",
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                  {
                                    padding: "8.5px 7px",
                                  },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                  {
                                    fontSize: "14px",
                                  },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                  {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none",
                                  },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                  {
                                    color: "input.font",
                                  },
                                  ".css-14qz1ij-MuiListItemText-root": {
                                    margin: "0px",
                                  },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                  minWidth: "100px",
                                  border: "none",
                                  "& .MuiInput-underline:before": {
                                    borderBottom: "none",
                                  },
                                  "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                  {
                                    borderBottom: "none", // Remove hover effect
                                  },
                                  "& .MuiInput-underline:after": {
                                    borderBottom: "none",
                                  },
                                }}
                                placeholder={"Search"}
                                variant="standard"
                                {...params}
                              />
                            )}
                          />

                          <IconButton type="button" sx={{ p: "0px" }}>
                            {filterColumns.TaxabilityCD !== "" ? (
                              <Clear
                                fontSize="small"
                                onClick={() => {
                                  setFilterColumns((prev) => ({
                                    ...prev,
                                    TaxabilityCD: "",
                                  }));
                                }}
                              />
                            ) : (
                              <SearchIcon fontSize="small" />
                            )}
                          </IconButton>
                        </Paper>
                      </TableCell>
                    )}
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <Stack
                        direction={'row'}
                        height={"32px"}
                        gap="5px"
                      >

                        <MoneyTextFieldRange
                          value={[filterColumns.PurchasePriceFrom,filterColumns.PurchasePriceTo]
                          }
                          onChange={(e) => {
                            handleFilterBySearch(e, "PurchasePrice", e);
                          }}
                        />
                        <IconButton type="button" sx={{ p: "0px" }}>
                          {filterColumns.PurchasePriceFrom !== "" &&
                            filterColumns.PurchasePriceTo ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  PurchasePriceFrom: "",
                                  PurchasePriceTo: "",
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>
                  <TableCell>
                    <Paper
                      sx={{
                        p: "2px 4px",
                        width: "100%",
                      }}
                    >
                      <Stack
                        direction={'row'}
                        height={"32px"}
                        gap="5px"
                      >
                        <MoneyTextFieldRange
                          value={[filterColumns.SalesPriceFrom,filterColumns.SalesPriceTo]}
                          onChange={(e) => {
                            handleFilterBySearch(e, "SalesPrice", e);
                          }}
                        />

                        <IconButton type="button" sx={{ p: "0px" }}>
                          {filterColumns.SalesPriceFrom !== "" &&
                            filterColumns.SalesPriceTo ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  SalesPriceFrom: "",
                                  SalesPriceTo: "",
                                }));
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Stack>
                    </Paper>
                  </TableCell>

                  <TableCell sx={{ minWidth: "97px" }} className="actionBackGround"></TableCell>
                </TableRow>
                {addEvent === true && (
                  <AddNewItemRow
                    allAccountArr={allAccountArr}
                    updateList={updateList}
                    editedRows={editedRows}
                    setInitialState={setInitialState}
                    setEditedRows={setEditedRows}
                    setAddEvent={setAddEvent}
                    purchaseArr={purchaseArr}
                    salesArr={salesArr}
                    Taxability={Taxability}
                    units={units}
                    setTaxableValue={setTaxableValue}
                    taxableValue={taxableValue}
                    setRegistrationType={setRegistrationType}
                    registrationType={registrationType}
                    showItems={showItems}
                    clasess={classes}
                    setBackdropOpen={setBackdropOpen}
                    fyID={userPreferenceAndFY?.financialYear?.FinancialYearID}
                    filterColumns={filterColumns}
                    listItemDetails={() => listItemDetailsv2(false, 0, 1)}
                    itemID={""}
                    itemTimeStamp={""}
                    rows={rows}
                    setRows={setRows}
                    todayDate={todayDate}
                    sellingPriceRows={sellingPriceRows}
                    setSellingPriceRows={setSellingPriceRows}
                    editedSellingPriceRows={editedSellingPriceRows}
                    setEditedSellingPriceRows={setEditedSellingPriceRows}
                    tempSellingPriceRows={setEditedSellingPriceRows}
                    setTempSellingPriceRows={setTempSellingPriceRows}
                    purchasePriceRows={purchasePriceRows}
                    setPurchasePriceRows={setPurchasePriceRows}
                    editedPurchasePriceRows={editedPurchasePriceRows}
                    setEditedPurchasePriceRows={setEditedPurchasePriceRows}
                    tempPurchasePriceRows={tempPurchasePriceRows}
                    setTempPurchasePriceRows={setTempPurchasePriceRows}
                    params={params}
                    setParams={setParams}
                    setSalesArr={setSalesArr}
                    setPurchaseArr={setPurchaseArr}
                    newUnit={newUnit}
                    setNewUnit={setNewUnit}
                    setUQCArray={setUQCArray}
                    setUnits={setUnits}
                    uqcArray={uqcArray}
                    getCompany={getCompany}
                    setActiveRow={setActiveRow}
                    activeRow={activeRow}
                    setCategoryId={setCategoryId}
                    categoryId={categoryId}
                    mainCategoryId={mainCategoryId}
                    setMainCategoryId={setMainCategoryId}
                    isFocusItem={isFocusItem}
                    setIsFocusItem={setIsFocusItem}
                    handleResetScroll={() => handleResetScroll()}
                    priceTypeArr={priceTypeArr}
                    newSalesObj={newSalesObj}
                    newPurchaseObj={newPurchaseObj}
                    setPriceTypeArr={setPriceTypeArr}
                    priceTypeID={priceTypeID}
                    setPriceTypeID={setPriceTypeID}
                    setDeletedPurchaseRows={setDeletedPurchaseRows}
                    setDeletedSalesRows={setDeletedSalesRows}
                    deletedSalesRows={deletedSalesRows}
                    deletedPurchaseRows={deletedPurchaseRows}
                    previousID={previousID}
                    setPreviousID={setPreviousID}
                    setEditAble={setEditAble}
                    dataCount={dataCount}
                    showActions = {showActions}
                  />
                )}
                {rows.length ? (
                  rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((col, ind) => {
                      const isItemSelected = isSelected(col.itemId);
                      const labelId = `enhanced-table-checkbox-${ind}`;
                      if (col.editable && itemID) {
                        return (
                          <AddNewItemRow
                            allAccountArr={allAccountArr}
                            updateList={updateList}
                            editedRows={editedRows}
                            setEditedRows={setEditedRows}
                            setAddEvent={setAddEvent}
                            purchaseArr={purchaseArr}
                            salesArr={salesArr}
                            Taxability={Taxability}
                            units={units}
                            setTaxableValue={setTaxableValue}
                            taxableValue={taxableValue}
                            setRegistrationType={setRegistrationType}
                            registrationType={registrationType}
                            showItems={showItems}
                            clasess={classes}
                            setBackdropOpen={setBackdropOpen}
                            fyID={
                              userPreferenceAndFY?.financialYear
                                ?.FinancialYearID
                            }
                            listItemDetails={() => listItemDetails()}
                            itemID={itemID}
                            itemTimeStamp={itemTimeStamp}
                            rows={rows}
                            setRows={setRows}
                            todayDate={todayDate}
                            sellingPriceRows={sellingPriceRows}
                            setSellingPriceRows={setSellingPriceRows}
                            editedSellingPriceRows={editedSellingPriceRows}
                            setEditedSellingPriceRows={
                              setEditedSellingPriceRows
                            }
                            tempSellingPriceRows={setEditedSellingPriceRows}
                            setTempSellingPriceRows={setTempSellingPriceRows}
                            purchasePriceRows={purchasePriceRows}
                            setPurchasePriceRows={setPurchasePriceRows}
                            editedPurchasePriceRows={editedPurchasePriceRows}
                            setEditedPurchasePriceRows={
                              setEditedPurchasePriceRows
                            }
                            tempPurchasePriceRows={tempPurchasePriceRows}
                            setTempPurchasePriceRows={setTempPurchasePriceRows}
                            params={params}
                            setParams={setParams}
                            setSalesArr={setSalesArr}
                            setPurchaseArr={setPurchaseArr}
                            newUnit={newUnit}
                            setNewUnit={setNewUnit}
                            setUQCArray={setUQCArray}
                            setUnits={setUnits}
                            uqcArray={uqcArray}
                            getCompany={getCompany}
                            setActiveRow={setActiveRow}
                            activeRow={activeRow}
                            setCategoryId={setCategoryId}
                            categoryId={categoryId}
                            mainCategoryId={mainCategoryId}
                            setMainCategoryId={setMainCategoryId}
                            isFocusItem={isFocusItem}
                            setIsFocusItem={setIsFocusItem}
                            handleResetScroll={() => handleResetScroll()}
                            priceTypeArr={priceTypeArr}
                            setPriceTypeArr={setPriceTypeArr}
                            priceTypeID={priceTypeID}
                            newSalesObj={newSalesObj}
                            newPurchaseObj={newPurchaseObj}
                            setPriceTypeID={setPriceTypeID}
                            setDeletedPurchaseRows={setDeletedPurchaseRows}
                            setDeletedSalesRows={setDeletedSalesRows}
                            deletedSalesRows={deletedSalesRows}
                            deletedPurchaseRows={deletedPurchaseRows}
                            previousID={previousID}
                            setPreviousID={setPreviousID}
                            setEditAble={setEditAble}
                            dataCount={dataCount}
                            showActions = {showActions}
                          />
                        );
                      } else {
                        return (
                          <TableRow
                            className={
                              col?.Is_Active == 1
                                ? classes.table
                                : classes.inActiveRow
                            }
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={ind}
                            selected={isItemSelected}
                            style={{ cursor: "pointer" }}
                            sx={{ "& > *": { fontSize: "12px" } }}
                          >
                            <TableCell
                              onClick={() => {
                                handleCellClick(col);
                              }}
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              padding="checkbox"
                              sx={{
                                ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root":
                                {
                                  padding: "5px",
                                },
                              }}
                              align="center"
                            >
                              <Checkbox
                                disableRipple
                                color="primary"
                                onClick={(event) => {
                                  event.stopPropagation();
                                  if (
                                    col.itemId !== "" ||
                                    col.itemId !== undefined
                                  ) {
                                    handleClick(event, col.itemId);
                                  }
                                }}
                                checked={isItemSelected}
                                inputProps={{
                                  "aria-labelledby": labelId,
                                }}
                                size="small"
                              />
                            </TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              sx={{ fontSize: "12px" }}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.type === 1 ? "GOODS" : "SERVICE"}
                            </TableCell>
                            {/* <TableCell
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            ></TableCell> */}

                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.itemCode}
                            </TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.itemName}
                            </TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.categoryObj?.label}
                            </TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.unitObj?.label}
                            </TableCell>
                            {companyType!==1 &&(
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col?.hsnObj?.value}
                            </TableCell>)}
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >{`${col?.showItemString ? col?.showItemString : ""
                              }`}</TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.purchaseAccount?.label}
                            </TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                            >
                              {col.salesAccount?.label}
                            </TableCell>
                            {getCompany?.relatedcompanydetailsnew?.[0]
                              .registrationtype != 1 && (
                                <TableCell sx={{ width: "auto !important" }}
                                  title={col.Is_Active === 1 ? "" : "Inactive"}
                                >
                                  {col.taxability.label}
                                </TableCell>
                              )}

                            <TableCell
                              onClick={() => {
                                handleCellClick(col);
                              }}
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              align="right"
                              sx={{ flexGrow: 1, minWidth: 100 }}
                            >
                              <span
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (
                                    (col?.taxability?.value != 1 &&
                                      col?.taxability?.value != 4) ||
                                    getCompany?.relatedcompanydetailsnew?.[0]
                                      .registrationtype == 1
                                  ) {
                                    setRegistrationType(1);
                                  } else {
                                    setRegistrationType("");
                                  }
                                  setViewPriceModal(true);
                                  setActiveRow(false);
                                  setAddEvent(false);
                                  setParams({
                                    id: col?.itemId,
                                    view: true,
                                    salesFlag: col?.salesInvoiceFlag,
                                    purchaseFlag: col?.purchaseInvoiceFlag,
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  flexGrow: 1,
                                  minWidth: 100,
                                }}
                              >
                                <span style={{}}>
                                  {col.registrationType == 1 ||
                                    getCompany?.relatedcompanydetailsnew?.[0]
                                      .registrationtype == 1
                                    ? MoneyFormatv3(col.purchaseTaxableAmt)
                                    : MoneyFormatv3(col.purchaseAmt)}
                                </span>
                                <span style={{ marginLeft: 5 }}>
                                  <Tooltip
                                    title={"View Price"}
                                    placement="right"
                                    disableInteractive
                                    arrow
                                  >
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "3px",
                                        backgroundColor: "#fbc7c78c",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (
                                          (col?.taxability?.value != 1 &&
                                            col?.taxability?.value != 4) ||
                                          getCompany
                                            ?.relatedcompanydetailsnew?.[0]
                                            .registrationtype == 1
                                        ) {
                                          setRegistrationType(1);
                                        } else {
                                          setRegistrationType("");
                                        }
                                        setViewPriceModal(true);
                                        setActiveRow(false);
                                        setAddEvent(false);
                                        setParams({
                                          id: col?.itemId,
                                          view: true,
                                          salesFlag: col?.salesInvoiceFlag,
                                          purchaseFlag:
                                            col?.purchaseInvoiceFlag,
                                        });
                                      }}
                                    >
                                      <Visibility
                                        sx={{
                                          fontSize: "15px",
                                          color: "#eb6a6a",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </span>{" "}
                              </span>
                            </TableCell>
                            <TableCell
                              title={col.Is_Active === 1 ? "" : "Inactive"}
                              onClick={() => {
                                handleCellClick(col);
                              }}
                              align="right"
                              sx={{ flexGrow: 1, minWidth: 100 }}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  flexGrow: 1,
                                  minWidth: 100,
                                }}
                              >
                                <span style={{}}>
                                  {col.registrationType == 1 ||
                                    getCompany?.relatedcompanydetailsnew?.[0]
                                      .registrationtype == 1 ||    getCompany?.relatedcompanydetailsnew?.[0]
                                      .registrationtype === 3
                                    ? MoneyFormatv3(col.salesTaxableAmt)
                                    : MoneyFormatv3(col.sellingprice)}
                                </span>
                                <span style={{ marginLeft: 5 }}>
                                  <Tooltip
                                    title={"View Price"}
                                    placement="right"
                                    disableInteractive
                                    arrow
                                  >
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "3px",
                                        backgroundColor: "#fbc7c78c",
                                      }}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        if (
                                          (col?.taxability?.value != 1 &&
                                            col?.taxability?.value != 4) ||
                                          getCompany
                                            ?.relatedcompanydetailsnew?.[0]
                                            .registrationtype == 1
                                        ) {
                                          setRegistrationType(1);
                                        } else {
                                          setRegistrationType("");
                                        }
                                        setViewPriceModal(true);
                                        setActiveRow(false);
                                        setAddEvent(false);
                                        setParams({
                                          id: col?.itemId,
                                          view: true,
                                          salesFlag: col?.salesInvoiceFlag,
                                          purchaseFlag:
                                            col?.purchaseInvoiceFlag,
                                        });
                                      }}
                                    >
                                      <Visibility
                                        sx={{
                                          fontSize: "15px",
                                          color: "#eb6a6a",
                                        }}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </span>{" "}
                              </span>
                            </TableCell>
                            <TableCell
                              className={classes.stickyCell}
                              sx={{position :!showActions ? 'relative' : 'sticky',backgroundColor:"white"}}
                              align="center"
                            // sx={{
                            //   position: "sticky",
                            //   right: 0,
                            //   backgroundColor: theme.palette.bodyGray.secondary,
                            //   zIndex: 10,
                            //   // outline: "4px solid rgba(224, 224, 224, 1)",
                            // }}
                            >
                              <Box
                                sx={{
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Tooltip
                                  title={
                                    col.Is_Active == 1
                                      ? "Mark as Inactive"
                                      : "Mark as Active"
                                  }
                                  placement="left"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    onClick={(event) => {
                                      event.stopPropagation();
                                      if (Freeze == 1) {
                                        return handleFreeze();
                                      }

                                      setEditData(col);
                                      setActiveValueModal(true);

                                      // markAsInActive(col, ind);
                                    }}
                                    aria-label=""
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "white",
                                      border:"solid 1px black",
                                      borderRadius: "50%"
                                        // col?.Is_Active == 1
                                        //   ? "#FEF3C7"
                                        //   : "#FEF3C7",
                                      // backgroundColor: "#c1f2f5a1",
                                    }}
                                  >
                                    {col?.Is_Active == 1 ? (
                                      <CheckCircleOutline
                                        sx={{
                                          fontSize: "15px",
                                          color: "green",
                                          // color: "#057d86",
                                        }}
                                      />
                                    ) : (
                                      <DoDisturbAlt
                                        sx={{
                                          fontSize: "15px",
                                          color: "red",
                                          // color: "#057d86",
                                        }}
                                      />
                                    )}
                                  </IconButton>
                                </Tooltip>
                                <Tooltip
                                  title={
                                    col.Is_Active == 1 ? "Edit" : "Cannot Edit"
                                  }
                                  placement="right"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor:
                                        col.Is_Active == 1
                                          ? "#D0EFFF"
                                          : "#9191912e",
                                      border:"solid 1px black",
                                      borderRadius: "50%"
                                    }}
                                    onClick={() => {
                                      setEditAble(true)
                                      if (col.Is_Active == 1) {
                                        if (Freeze == 1) {
                                          return handleFreeze();
                                        }
                                        setAddEvent(false);
                                        if (
                                          (col?.taxability?.value != 1 &&
                                            col?.taxability?.value != 4) ||
                                          getCompany
                                            ?.relatedcompanydetailsnew?.[0]
                                            .registrationtype == 1
                                        ) {
                                          col.purchaseAmt = Number(
                                            col.purchaseTaxableAmt
                                          );
                                          col.sellingprice = Number(
                                            col.salesTaxableAmt
                                          );
                                          setRegistrationType(1);
                                        } else {
                                          col.purchaseAmt = Number(
                                            col.purchaseNetAmt
                                          );
                                          col.sellingprice =companyType===3?Number(col?.salesTaxableAmt): Number(
                                            col.salesNetAmt
                                          );
                                          setRegistrationType("");
                                        }
                                        setCategoryId(col.itemCtegorey);
                                        setEditedRows(col);
                                        setItemID(col.itemId);
                                        setParams({
                                          id: col?.itemId,
                                          view: false,
                                          salesFlag: col?.salesInvoiceFlag,
                                          purchaseFlag:
                                            col?.purchaseInvoiceFlag,
                                        });
                                        setItemTimeStamp(col?.timeStamp);
                                        let arr = [...rows];
                                        let tempArr = arr.filter(
                                          (ele, index) => {
                                            if (ele.new !== true) {
                                              if (ele.itemId == col.itemId) {
                                                ele.editable = true;
                                                ele.new = false;
                                              } else {
                                                ele.editable = false;
                                                ele.new = false;
                                              }
                                              return ele;
                                            }
                                          }
                                        );
                                        setRows(tempArr);
                                      }
                                    }}
                                  >
                                    {col.Is_Active == 1 ? (
                                      <Edit
                                        sx={{
                                          fontSize: "15px",
                                          color: "#6096d9",
                                        }}
                                      />
                                    ) : (
                                      <EditOff sx={{ fontSize: "15px" }} />
                                    )}
                                  </IconButton>
                                </Tooltip>

                                <Tooltip
                                  title={"Delete"}
                                  placement="right"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    disableRipple
                                    onClick={(event) => {
                                      if (Freeze == 1) {
                                        return handleFreeze();
                                      }
                                      handleDeleteClick(col, ind);
                                    }}
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      // backgroundColor: "#fbc7c7",
                                      backgroundColor:"white",
                                      border:"solid 1px black",
                                      borderRadius: "50%"
                                    }}
                                  >
                                    <Delete
                                      sx={{
                                        fontSize: "15px",
                                        color: "#eb6a6a",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>

                                {/* <Tooltip
                                title={"cancel"}
                                placement="right"
                                disableInteractive
                                arrow
                              >
                                <IconButton
                                  //   onClick={(event) => {
                                  //     Cancel(event, row, index);
                                  //   }}
                                  aria-label="delete"
                                  sx={{
                                    margin: "0px 2px",
                                    padding: "5px",
                                    backgroundColor: "#b1d1f97d",
                                  }}
                                >
                                  <Close
                                    sx={{ fontSize: "15px", color: "#6096d9" }}
                                  />
                                </IconButton>
                              </Tooltip> */}
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    })
                ) : circularOpen == false &&
                  rows.length <= 0 &&
                  !dataCount > 0 ? (
                  <TableRow
                  // sx={{ backgroundColor: theme.palette.bodyGray.secondary }}
                  >
                    <TableCell
                      height={500}
                      align="center"
                      colSpan={10}
                      sx={{ border: "none", }}
                    >
                      No Data Found
                    </TableCell>
                  </TableRow>
                ) : (
                  ""
                )}
                {circularOpen == true &&
                  limit > 0 &&
                  Array.from({ length: limit }, (_, index) => (
                    <TableRow key={index}>
                      <TableCell colSpan={14}>
                        <Skeleton variant="text" sx={{ fontSize: "2rem" }} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          {dataCount > 0 && (
            <TablePagination
              sx={{
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  // width: '0.4em',
                  height: "0.4em",
                },
                "&::-webkit-scrollbar-track": {
                  background: `${theme.palette.primary.main}47`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#057d86",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "#057d8647",
                },
                "& .MuiTablePagination-select": {
                  // backgroundColor: '#f5f5f5',  // Styling the dropdown
                  padding: "6px 10px", // Adjust padding
                  borderRadius: "4px", // Add border radius
                  // border: '1px solid #ddd',
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
              }}
              rowsPerPageOptions={defaultRowsPerPageOptions}
              component="div"
              count={dataCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>
      </Box>
      <DeleteGoodsItem
        open={deleteItemModal}
        setOpen={setDeleteItemModal}
        itemData={itemData}
        rows={rows}
        setRows={setRows}
        listItemDetails={() => listItemDetailsv2(true, 0, rowsPerPageRef.current)}
        setdataCount={setdataCount}
      />
      <DeleteSelectedItems
        setdataCount={setdataCount}
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        itemsData={selected}
        rows={rows}
        setRows={setRows}
        setSelected={setSelected}
        listItemDetails={()=>listItemDetailsv2(true, 0, rowsPerPageRef.current)}
        setSummaryData={setSummaryData}
      />
      <SummaryDialog data={SummaryData} />
      <Loader open={backdropOpen}></Loader>
      {viewPriceModal === true && (
        <PriceModal
          open={viewPriceModal}
          setOpen={setViewPriceModal}
          data={editedRows}
          todayDate={todayDate}
          sellingPriceRows={sellingPriceRows}
          setSellingPriceRows={setSellingPriceRows}
          editedSellingPriceRows={editedSellingPriceRows}
          setEditedSellingPriceRows={setEditedSellingPriceRows}
          tempSellingPriceRows={tempSellingPriceRows}
          setTempSellingPriceRows={setTempSellingPriceRows}
          purchasePriceRows={purchasePriceRows}
          setPurchasePriceRows={setPurchasePriceRows}
          editedPurchasePriceRows={editedPurchasePriceRows}
          setEditedPurchasePriceRows={setEditedPurchasePriceRows}
          tempPurchasePriceRows={tempPurchasePriceRows}
          setTempPurchasePriceRows={setTempPurchasePriceRows}
          setData={setEditedRows}
          params={params}
          setRegistrationType={setRegistrationType}
          registrationType={registrationType}
          setParams={setParams}
          getCompany={getCompany}
          setActiveRow={setActiveRow}
          activeRow={activeRow}
          priceTypeArr={priceTypeArr}
          newSalesObj={newSalesObj}
          newPurchaseObj={newPurchaseObj}
          priceTypeID={priceTypeID}
          setPriceTypeID={setPriceTypeID}
          setPriceTypeArr={setPriceTypeArr}
          setDeletedPurchaseRows={setDeletedPurchaseRows}
          setDeletedSalesRows={setDeletedSalesRows}
          deletedSalesRows={deletedSalesRows}
          deletedPurchaseRows={deletedPurchaseRows}
          previousID={previousID}
          taxableValue={taxableValue}
          setPreviousID={setPreviousID}
        />
      )}
      <SummaryDialog data={SummaryData} />
      {modalOpen && (
        <ConfirmExit
          open={modalOpen}
          setOpen={setModalOpen}
          reNavigate={reNavigate}
        />
      )}
      {/* {activeValueModal && (
        <ListingActive
          text={"Item"}
          open={activeValueModal}
          setOpen={setActiveValueModal}
          action={() => {
            markAsInActive(activeValueModal);
          }}
        />
      )} */}
      {activeValueModal && (
        <ItemActiveOrInActiveModal
          text={"Item"}
          open={activeValueModal}
          setOpen={setActiveValueModal}
          editData={editData}
          setRows={setRows}
          rows={rows}
          onComplete={() => {
            if (ListSelection === "Active" || ListSelection === "InActive") {
              setdataCount((prev) => prev - 1);
            }
          }}
        />
      )}
      {/* <ExportData
        setOpen={setExportModalOpen}
        open={exportModalOpen}
        item={exportItem}
      /> */}
    </Box>
  );
}

export default NewItemListPage;
